import { OutputParametricSelector, OutputSelector, createSelector } from 'reselect';
import { AppState } from 'src/store';
import { BreadcrumbRestore, CrumbPath } from './Bread.slice';
import { isEmpty, isNil, last } from 'lodash';
import { GroupViewItem } from 'src/services/configuration/codecs/viewdefns/general';

interface ActiveViewDefnItems {
  levelBys: GroupViewItem[];
  selectedLevel: GroupViewItem | undefined;
}

interface ActiveBreadcrumbsSelector
  extends OutputSelector<
    AppState,
    CrumbPath[] | null,
    (activeBreadcrumbKey: string | null, crumbPaths: Record<string, CrumbPath[]>) => CrumbPath[] | null
  > {}

interface ActiveBreadcrumbSelector
  extends OutputSelector<AppState, CrumbPath | null, (activeCrumbPaths: CrumbPath[]) => CrumbPath | null> {}

interface RestoreBreadcrumbLevelSelector
  extends OutputParametricSelector<
    AppState,
    ActiveViewDefnItems,
    GroupViewItem | undefined,
    (restore: BreadcrumbRestore, activeViewDefnItems: ActiveViewDefnItems) => GroupViewItem | undefined
  > {}

const getActiveBreadcrumbKey = (state: AppState): string | null => {
  return state.breadcrumbs.activeBreadcrumbKey;
};

const getCrumbPaths = (state: AppState): Record<string, CrumbPath[]> => {
  return state.breadcrumbs.crumbPaths;
};

const getActiveBreadcrumbRestore = (state: AppState): BreadcrumbRestore | null => {
  return state.breadcrumbs.activeBreadcrumbRestore;
};

const getActiveViewDefnItems = (_state: AppState, { levelBys, selectedLevel }: ActiveViewDefnItems) => {
  return { levelBys, selectedLevel };
};

export const getActiveBreadcrumbs: ActiveBreadcrumbsSelector = createSelector(
  getActiveBreadcrumbKey,
  getCrumbPaths,
  (activeBreadcrumbKey, crumbPaths) => {
    return activeBreadcrumbKey ? crumbPaths[activeBreadcrumbKey] : null;
  },
);

export const getActiveBreadcrumb: ActiveBreadcrumbSelector = createSelector(
  getActiveBreadcrumbs,
  (activeCrumbPaths) => {
    if (isNil(activeCrumbPaths) || isEmpty(activeCrumbPaths)) {
      return null;
    }
    return last<CrumbPath>(activeCrumbPaths) ?? null;
  },
);

export const maybeRestoreBreadcrumbLevel: RestoreBreadcrumbLevelSelector = createSelector(
  getActiveBreadcrumbRestore,
  getActiveViewDefnItems,
  (restore, { selectedLevel, levelBys }) => {
    return restore?.selectedLevel
      ? (levelBys.find((lb) => lb.dataIndex === restore.selectedLevel) ?? selectedLevel)
      : selectedLevel;
  },
);
